import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./reducers";

 //export default configureStore(rootReducer);

 
/*
const store = configureStore(rootReducer,
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__({ serialize: true, trace: true })
	);

*/


 const store = configureStore({ reducer: rootReducer });

export default store;
